import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import isEqual from 'lodash/isEqual';

import { selectAccessKeysIsDataReady } from '@/ducks/accessKeys';
import { getCabinCategories } from '@/ducks/cabinsCommon/cabinCategories/actions';
import { selectPayloadForCabinsFetch } from '@/ducks/cabinsCommon/selectors';
import { useGetBackToFlow } from '@/ducks/voyageInfo/booking/navigation';
import { selectVoyageId } from '@/ducks/voyageInfo/sailing/selectors';
import { selectCabinCategoriesApiPayload } from '@/reducers/voyagePlanner/chooseCabin/cabinCategories/selectors';
import { useAppDispatch, useAppSelector } from '@/store';

export const useFetchCabinCategories = () => {
  const dispatch = useAppDispatch();
  const searchParams = useSearchParams();
  const prevPayload = useAppSelector(selectCabinCategoriesApiPayload);

  const accessKeysIsDataReady = useAppSelector(selectAccessKeysIsDataReady);
  const payloadForCabinsFetch = useAppSelector(selectPayloadForCabinsFetch);
  const voyageId = useAppSelector((state) =>
    selectVoyageId(state, searchParams.get('packageCode'), searchParams.get('voyageId')),
  );

  const backToFlow = useGetBackToFlow();

  useEffect(() => {
    const payload = { ...payloadForCabinsFetch, voyageId };

    if (!voyageId || !accessKeysIsDataReady || isEqual(payload, prevPayload)) return;

    dispatch(
      getCabinCategories({
        onExhaustError: backToFlow,
        onFetchError: backToFlow,
        payloadForCabinsFetch: payload,
        voyageId,
      }),
    );
  }, [payloadForCabinsFetch, backToFlow, voyageId, accessKeysIsDataReady]);
};
